import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Box } from "@mui/material";
import Style from "./NotFound.module.scss";

export default function NotFound({ lang = "tr" }) {
  const isEn = lang === "en";

  return (
    <Box className={Style.page} component="section" aria-labelledby="not-found-title">
      <div className={Style.glow} aria-hidden="true" />
      <p className={Style.code}>404</p>
      <h1 id="not-found-title" className={Style.title}>
        {isEn ? "Page not found" : "Sayfa bulunamadı"}
      </h1>
      <p className={Style.copy}>
        {isEn
          ? "This route drifted off the map. Let's get you back to familiar ground."
          : "Bu rota haritada kaybolmuş. Seni tanıdık bir yere geri götürelim."}
      </p>
      <div className={Style.actions}>
        <Link to={isEn ? "/en/" : "/"} className={Style.primary}>
          {isEn ? "Back home" : "Ana sayfaya dön"}
        </Link>
        <Link to={isEn ? "/en/about" : "/about"} className={Style.secondary}>
          {isEn ? "About me" : "Hakkımda"}
        </Link>
      </div>
    </Box>
  );
}

NotFound.propTypes = {
  lang: PropTypes.oneOf(["tr", "en"]),
};
